import { selectBasketTime, resetTime, selectBasketList, BASKET_TYPES, selectBasketPaymentInProgress } from 'containers/OrderDetails/basketSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import React, { useEffect, useRef, useState } from 'react'
import Warning from 'containers/Header/WarningPopup'
import { useHistory } from 'react-router-dom'
import TimerContext from './Context'

interface TimerProviderProps {
  children: React.ReactNode
}

const INIT_TIME = 180

const TimerProvider: React.FC<TimerProviderProps> = ({ children }) => {
  const paymentsInProgress = useReduxSelector(selectBasketPaymentInProgress)
  const startTime = useReduxSelector(selectBasketTime)
  const list = useReduxSelector(selectBasketList)
  const [time, setTime] = useState(-1)
  const currentList = useRef(list)
  currentList.current = list

  const dispatch = useReduxDispatch()
  const { replace } = useHistory()

  useEffect(() => {
    setTime(startTime && !paymentsInProgress ? INIT_TIME : -1)
  }, [startTime, paymentsInProgress])

  useEffect(() => {
    if (time > 0) {
      const resetCounter = () => {
        dispatch(resetTime())
      }
      window.addEventListener('click', resetCounter)
      return () => {
        window.removeEventListener('click', resetCounter)
      }
    }
  }, [dispatch, time])

  useEffect(() => {
    if (time !== -1 && startTime > 0) {
      const interval = setInterval(() => {
        const newTime = INIT_TIME - ((Date.now() - startTime) / 1000)
        if (newTime < 1) {
          const lastWarehouse = currentList.current.findLast((item: any) => item.type === BASKET_TYPES.rent)
          replace(lastWarehouse?.placeId ? `/mapdetails/${lastWarehouse.placeId}` : '/map', { unlock: true })
          setTime(-1)
        } else {
          setTime(newTime)
        }
      }, 1000)
      return () => {
        clearInterval(interval)
      }
    }
  }, [replace, startTime, time])

  return (
    <TimerContext.Provider value={time}>
      {(time > 0 && time < 9) && <Warning time={time} />}
      {children}
    </TimerContext.Provider>
  )
}

export default TimerProvider